<div class="event-card-container" #container>
  <div
    class="card vertical reverse event {{ selected }}"
    [ngClass]="{ flipped: selected !== -1 || (flipped && !spoilerFree), disabled: disabled(), 'show-debug': showDebug }"
    [style.fontSize]="container.offsetWidth * 0.07 + 'px'"
  >
    <div
      class="card-back {{ !!event ? event.type : '' }}"
      [ngClass]="{ gh2e: !!event && event.edition === 'gh2e' }"
      [style.background-image]="
        showDebug && event
          ? 'url(\'./assets/artwork/events/debug/' + event.edition + '/' + event.type + '/' + event.cardId + '-back.png\')'
          : ''
      "
    >
      @if (!!event) {
        <div class="wrapper" [ngClass]="{ spoiler: spoilerFree }">
          <div class="content">
            <div class="text placeholder" [ghs-label]="event.narrative"></div>
            <div class="options">
              @for (option of event.options | trackUUID; track option._trackUUID; let i = $index) {
                @if (option.narrative) {
                  <div
                    class="option"
                    ghs-pointer-input
                    (singleClick)="selectOption(i, false, $event)"
                    [ngClass]="{ single: event.options.length === 1 || !option.label }"
                  >
                    @if (option.label) {
                      <span class="title" [ghs-label]="'game.events.option'" [ghs-label-args]="[option.label]"></span>
                    }
                    <span class="choice" [ghs-label]="option.narrative"></span>
                  </div>
                }
              }
            </div>
            @if (event.footer) {
              <div class="footer" [ghs-label]="event.footer"></div>
            }
          </div>
          @if (event.requirement && event.requirement.partyAchievement) {
            <div class="requirement party-achievement">
              <span [ghs-label]="'game.events.requirements'" [ghs-label-args]="[event.requirement.partyAchievement]"></span>
              <span
                [ghs-label]="'game.events.requirements.partyAchievement'"
                [ghs-label-args]="[event.requirement.partyAchievement]"
              ></span>
            </div>
          }
        </div>
        @if (spoilerFree) {
          <div class="spoiler-free" [ngClass]="{ light: light }">
            <a ghs-pointer-input (singleClick)="setSpoilerFree(false, $event)">{{ event.cardId }}</a>
          </div>
        }
        <div class="card-id" ghs-pointer-input (singleClick)="setSpoilerFree(true, $event)">{{ event.cardId }}</div>
      }
      @if (settingsManager.settings.debugEventCards) {
        <div class="show-debug-toggle" [ngClass]="{ light: light }" ghs-pointer-input (singleClick)="toggleShowDebug($event)">
          <img src="./assets/images/debug.svg" />
        </div>
      }
    </div>
    <div
      class="card-front {{ !!event ? event.type : '' }}"
      [ngClass]="{ gh2e: !!event && event.edition === 'gh2e' }"
      [style.background-image]="
        showDebug && event
          ? 'url(\'./assets/artwork/events/debug/' + event.edition + '/' + event.type + '/' + event.cardId + '-front.png\')'
          : ''
      "
    >
      @if (!!event) {
        <div class="options" [ngClass]="{ 'no-label': noLabel }">
          @for (option of event.options | trackUUID; track option._trackUUID; let i = $index) {
            <div
              class="option {{ 'option-' + (option.label || 'no-label') }} {{ 'option-bg-' + (event.options.length - i) }}"
              [ngClass]="{
                selected: !option.label || selected === i || (selected === -1 && flipped),
                single: event.options.length === 1,
                'no-label': !option.label,
                attack: attackIndex === i
              }"
              ghs-pointer-input
              (doubleClick)="selectOption(selected === i ? -1 : i, false, $event)"
            >
              @for (outcome of option.outcomes | trackUUID; track outcome._trackUUID; let outcomeIndex = $index) {
                <div
                  class="outcome"
                  [ngClass]="{
                    selected: subSelections.includes(outcomeIndex) || (selected === -1 && flipped) || (!option.label && outcome.attack),
                    disabled:
                      resolvable[i] && resolvable[i][outcomeIndex] === false && !subSelections.includes(outcomeIndex) && selected !== -1,
                    'expand-to-bottom': outcomeIndex === option.outcomes.length - 1 && (option.returnToDeck || option.removeFromDeck),
                    margin: outcome.condition || outcome.narrative
                  }"
                  ghs-pointer-input
                  (singleClick)="selectSub(i, outcomeIndex, $event)"
                  (doubleClick)="selectSub(i, outcomeIndex, true, $event)"
                >
                  @if (outcome.condition) {
                    <ghs-event-card-condition
                      [condition]="outcome.condition"
                      [narrative]="true"
                      [edition]="event.edition"
                      [eventType]="event.type"
                      [light]="light"
                      [selected]="(selected === -1 && flipped) || (selected === i && subSelections.includes(outcomeIndex))"
                      [debug]="debug()"
                    ></ghs-event-card-condition>
                  }
                  @if (outcome.condition) {
                    <span class="condition-spacer">:</span>
                  }
                  @if (outcome.narrative) {
                    <span
                      class="text"
                      [ngClass]="{ 'text-white': light, inline: outcome.inlineEffects && outcome.effects.length }"
                      [ghs-label]="outcome.narrative"
                    ></span>
                  }
                  @if (outcome.effects && outcome.effects.length) {
                    <div class="effects" [ngClass]="{ inline: outcome.inlineEffects }">
                      @for (
                        effect of outcome.effects;
                        track (typeof effect === 'object' ? effect.type : effect) + ('' + $index);
                        let effectIndex = $index
                      ) {
                        <ghs-event-card-effect
                          [effect]="effect"
                          [edition]="event.edition"
                          [eventType]="event.type"
                          [light]="light"
                          [selected]="(selected === -1 && flipped) || (selected === i && subSelections.includes(outcomeIndex))"
                          [inline]="outcome.inlineEffects || false"
                          [checks]="(!!checks && checks[effectIndex]) || 0"
                          (checksChange)="onCheck(effectIndex, $event)"
                          [debug]="debug()"
                        ></ghs-event-card-effect>
                      }
                    </div>
                  }
                  @if (outcome.attack) {
                    <ghs-event-card-attack
                      [attack]="outcome.attack"
                      [edition]="event.edition"
                      [eventType]="event.type"
                      [light]="light"
                      [selected]="attack"
                      (selectedChange)="toggleAttack($event)"
                      [debug]="debug()"
                    ></ghs-event-card-attack>
                  }
                  @if (
                    outcome.returnToDeck ||
                    outcome.removeFromDeck ||
                    (outcomeIndex === option.outcomes.length - 1 && (option.returnToDeck || option.removeFromDeck))
                  ) {
                    <div class="card-action">
                      @if (outcome.returnToDeck || option.returnToDeck) {
                        <img class="ghs-svg" src="./assets/images/eventcards/return.svg" />
                      }
                      @if (outcome.removeFromDeck || option.removeFromDeck) {
                        <img class="ghs-svg" src="./assets/images/eventcards/remove.svg" />
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="card-id">{{ event.cardId }}</div>
      }
      @if (settingsManager.settings.debugEventCards) {
        <div class="show-debug-toggle" [ngClass]="{ light: light }" ghs-pointer-input (singleClick)="toggleShowDebug($event)">
          <img src="./assets/images/debug.svg" />
        </div>
      }
    </div>
  </div>
</div>
